export enum HttpError {
  NAME_NOT_RESOLVED,
  CLIENT_ERROR,
  SERVER_ERROR
}
